import React from 'react';
import SimpleAccordion from '@/components/accordion/SimpleAccordion';
import CatalogueFieldList from '../../forms/components/CatalogueFieldList';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const DatasetCatalogueAccordionFieldList = ({
  category,
  children,
  code,
  direction,
  index = 0,
  panel,
  section,
  url,
}) => {
  const {
    active,
    hasChildren,
    label,
  } = Selectors.useDatasetCatalogueAccordionFieldList({
    category, code, section, panel, index, url,
  });
  const updatePanels = Events.useUpdateCataloguePanels(category, { code });
  return (
    <SimpleAccordion
      active={active}
      headerText={label}
      index={index}
      onClick={() => updatePanels({ index, panel })}
    >
      <CatalogueFieldList code={code} category={category} direction={direction} section={section}>
        {hasChildren && (<>{children}</>)}
      </CatalogueFieldList>
    </SimpleAccordion>
  );
};

export default DatasetCatalogueAccordionFieldList;
